import React from "react";
import useCheckMobileScreen from "../../hooks/useCheckMobileScreen";
import { HOME_PENCIL_BANNER_WEB } from "../../helpers/brazePlacementIds";
import BrazeBannerSlot from "../Braze/BrazeBannerSlot";
import styles from "./PencilBrazeBanner.module.scss";
/**
 * Full-width pencil banner fixed at the very top of the header (desktop only).
 * Updates --get-nav-height-* CSS vars via the shared banner layout registry.
 */
const PencilBrazeBanner: React.FC = () => {
  const isMobile = useCheckMobileScreen();

  if (isMobile) return null;

  return (
    <BrazeBannerSlot
      placementId={HOME_PENCIL_BANNER_WEB}
      logLabel="PencilBrazeBanner"
      className={styles.pencilBannerSlot}
      ariaLabel="Promotional pencil banner"
      animateHeight
      keepMounted
    />
  );
};

export default PencilBrazeBanner;
